import { useState } from "react";

import type { MemberCustomerVo } from "@zhihaoscm/entity";
import { dashboardService } from "@/api/services/dashboardService";
import { formatThousandSeparator } from "@/utils/money";
import {
    DashboardDateSelect,
    type DashboardDateValue,
    DataWrap,
    toDashboardDateParams,
    useDashboardQuery,
    WidgetBody
} from "../dashboardWidgets";

const ADDITION_METRICS = [
    { label: "新增基础会员", key: "addBaseMemberNum", colorClass: "color1" },
    { label: "新增高级会员", key: "addSeniorMemberNum", colorClass: "color2" },
    { label: "新增企业会员", key: "addEnterpriseGradeMemberNum", colorClass: "color3" }
] as const;

/** 会员用户新增统计，复刻 Vue 的三块渐变指标卡。 */
export default function AddMemberCustomerStatistic() {
    const [time, setTime] = useState<DashboardDateValue>(2);
    const { data, loading, error } = useDashboardQuery<Partial<MemberCustomerVo>>(
        () => dashboardService.getAddMemberCustomerStatistic(toDashboardDateParams(time)),
        [time]
    );

    return (
        <DataWrap
            title="会员用户新增统计"
            className="add-member-customer-statistic"
            option={
                <DashboardDateSelect
                    value={time}
                    onChange={setTime}
                    options={["month", "quarter", "year"]}
                    defaultActive="month"
                />
            }
        >
            <WidgetBody loading={loading} error={error}>
                <div className="member-addition-list">
                    {ADDITION_METRICS.map(metric => (
                        <div className={`member-addition-card ${metric.colorClass}`} key={metric.key}>
                            <span className="member-addition-label">{metric.label}</span>
                            <span className="member-addition-value">
                                {formatThousandSeparator(data?.[metric.key] || 0, 0)}
                                <i>人</i>
                            </span>
                        </div>
                    ))}
                </div>
            </WidgetBody>
        </DataWrap>
    );
}
